import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useProject } from "@/context/ProjectContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtDateTime } from "@/components/badges";
import { useTranslation } from "react-i18next";

export function AuditTab() {
  const { t } = useTranslation();
  const { selectedId } = useProject();

  const { data: audit = [] } = useQuery({
    queryKey: ["admin-audit", selectedId],
    queryFn: async () => (await api.get(`/projects/${selectedId}/audit`)).data,
    enabled: !!selectedId,
  });

  return (
    <Card>
      <CardHeader className="pb-2"><CardTitle className="text-base">{t("admin.auditCard")}</CardTitle></CardHeader>
      <CardContent className="overflow-x-auto p-0">
        <Table>
          <TableHeader><TableRow><TableHead>{t("admin.thTime")}</TableHead><TableHead>{t("admin.thUser")}</TableHead><TableHead>{t("progress.party")}</TableHead><TableHead>{t("admin.thWorkItem")}</TableHead><TableHead>{t("admin.thChange")}</TableHead><TableHead>{t("admin.thNote")}</TableHead></TableRow></TableHeader>
          <TableBody>
            {audit.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-sm text-slate-500" data-testid="audit-empty">{t("admin.auditEmpty")}</TableCell></TableRow>}
            {audit.map((a) => (
              <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
                <TableCell className="font-mono text-xs text-slate-500">{fmtDateTime(a.created_at)}</TableCell>
                <TableCell className="text-sm">{a.user_email}</TableCell>
                <TableCell className="text-sm">{a.party_company}</TableCell>
                <TableCell className="text-sm font-medium">{a.item_title}</TableCell>
                <TableCell className="font-mono text-xs">
                  {a.kind === "activity" ? a.action : a.old_progress != null ? `${a.old_progress}% → ${a.new_progress}%` : t("admin.created")}
                </TableCell>
                <TableCell className="text-xs italic text-slate-500">{a.note || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
